var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conference"},[(_vm.item && _vm.user)?_c('div',{staticClass:"conference-body"},[_c('vue-jitsi-meet',{ref:"jitsiRef",attrs:{"domain":"jitsi.avtest.uz","options":_vm.jitsiOptions}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }